/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  CustomerSegmentResponse
} from './data.schemas'




export const getCustomerSegments = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerSegmentResponse[]>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/segments`,options
    );
  }


export const getGetCustomerSegmentsQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/customers/segments`] as const;
    }

    
export const getGetCustomerSegmentsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerSegments>>, TError = AxiosError<unknown>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSegments>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerSegmentsQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerSegments>>> = ({ signal }) => getCustomerSegments(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerSegments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerSegmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerSegments>>>
export type GetCustomerSegmentsQueryError = AxiosError<unknown>

export const useGetCustomerSegments = <TData = Awaited<ReturnType<typeof getCustomerSegments>>, TError = AxiosError<unknown>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSegments>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCustomerSegmentsQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetCustomerSegments = async <TData = Awaited<ReturnType<typeof getCustomerSegments>>, TError = AxiosError<unknown>>(
 queryClient: QueryClient, segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSegments>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCustomerSegmentsQueryOptions(segmentationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


